import { useState } from "react";
import moment from "moment";
import { APIEndpoint, DFPAPIEndpoint } from "../../utils/axios";
import downloadIcon from "../../assets/icons/download-master.svg";
import "./NotificationDetailModal.scss";
import { getEventTitle } from "./utils/getEventTitle";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const NotificationDetailModal = ({ notification, onClose }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  if (!notification) return null;

  const sType = localStorage.getItem("sType");
  const DOMAIN = sType === "dfp" ? DFPAPIEndpoint : APIEndpoint;

  const getPriorityColor = (priority) => {
    const priorityUpper = priority?.toUpperCase();

    if (priorityUpper === "HIGH" || priorityUpper === "CRITICAL") {
      return "#dc3545"; // Red
    } else if (priorityUpper === "MEDIUM") {
      return "#ffc107"; // Dark Yellow
    } else if (priorityUpper === "LOW") {
      return "#28a745"; // Green
    }
    return "#e0e0e0"; // Default color
  };

  const handleDownload = async () => {
    const jobId = notification.metadata?.jobId;

    if (!jobId) {
      return;
    }

    setIsDownloading(true);

    try {
      // Check download status
      const dowId = await DOMAIN.get(`downloads/status/${jobId}`);

      if (dowId.status === "completed") {
        // Download the file
        const fileData = await DOMAIN.get(
          `downloads/analytics/${dowId.fileName}${dowId.fileExtension}`
        );

        const url = window.URL.createObjectURL(new Blob([fileData]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${dowId.fileName}${dowId.fileExtension}`
        );
        document.body?.appendChild(link);
        link.click();
        document.body?.removeChild(link);
        window.URL.revokeObjectURL(url);

        setIsDownloading(false);
      } else {
        toast.error('File not found', {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: false,
          autoClose: 3800,
        });
        setIsDownloading(false);
      }
    } catch (error) {
      setIsDownloading(false);
      toast.error('Error downloading file', {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: false,
        autoClose: 3800,
      });
    }
  };

  return (
    <>
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="flexRow alignItemsCenter gap10">
            <h2 className="modal-title">
              {getEventTitle(notification.type) || "Notification"}
            </h2>
            {notification.priority && (
              <>
                <span
                  className="priority-badge"
                  style={{
                    color: getPriorityColor(notification.priority),
                    fontWeight: "600",
                  }}
                >
                  {notification.priority}
                </span>
              </>
            )}
          </div>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="notification-detail-section">
            <div className="detail-row">
              <label className="detail-label">Title:</label>
              <p className="detail-value">{notification.title || "N/A"}</p>
            </div>

            <div className="detail-row">
              <label className="detail-label">Message:</label>
              <p className="detail-value">{notification.message || "N/A"}</p>
            </div>

            <div className="detail-row">
              <label className="detail-label">Created At:</label>
              <p className="detail-value">
                {notification.createdAt
                  ? moment(notification.createdAt).format(
                      "DD-MM-YYYY hh:mm:ss A"
                    )
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          {notification.type === "DOWNLOAD_STATUS" &&
            notification.metadata?.jobId && (
              <button
                className="btn-download"
                onClick={handleDownload}
                disabled={isDownloading}
              >
                <img src={downloadIcon} alt="Download" className="btn-icon" />
                {isDownloading ? "Downloading..." : "Download"}
              </button>
            )}
        </div>
      </div>
    </div>
    <ToastContainer />
    </>
  );
};
